import { format } from 'date-fns'

import styles from './ControllerVehicleAllocation.module.scss'

import { VehicleAllocationList } from './AllocationList/VehicleAllocationList'
import { useDateStore } from '@/components/DateInput'
import { useWorkstationStore } from '@/modules/Workstation/store'
import { useVehicleAllocationStore } from '../store'
import { useEffect } from 'react'

export const ControllerVehicleAllocation = () => {
    const { workstation } = useWorkstationStore()
    const { date } = useDateStore()
    const { clearStore } = useVehicleAllocationStore()

    useEffect(() => {
        return () => clearStore()
    }, [])

    return (
        <section className={styles.root}>
            <header className={styles.header}>
                <div className={styles.details}>
                    <h1 className={styles.title}>{workstation?.workstationNumber} vehicle allocation</h1>
                    <p className={styles.date}>{format(date, 'cccc d MMMM')}</p>
                </div>
            </header>

            <div className={styles.container}>
                <VehicleAllocationList />
            </div>
        </section>
    )
}
